var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9407 6.58696H7.91309H7.91306V0.559254C7.61417 0.520344 7.30945 0.5 7 0.5C6.69055 0.5 6.38583 0.520344 6.08696 0.559254V6.58691V6.58694H0.0592539C0.0203438 6.88583 0 7.19055 0 7.5C0 7.8095 0.0203438 8.11417 0.0592539 8.41303H6.08691H6.08694V14.4407C6.38583 14.4797 6.69055 14.5 7 14.5C7.30945 14.5 7.61417 14.4797 7.91303 14.4407V8.41309V8.41306H13.9407C13.9797 8.11417 14 7.8095 14 7.5C14 7.19055 13.9797 6.88583 13.9407 6.58696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26085 3.84823V2.93517H3.34782V3.84823H2.43475V4.76126H3.34782V5.6743H4.26085V4.76126H5.17389V3.84823H4.26085Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6522 3.84823V2.93517H9.73915V3.84823H8.82611V4.76126H9.73915V5.6743H10.6522V4.76126H11.5652V3.84823H10.6522Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26085 10.2397V9.32669H3.34782V10.2397H2.43475V11.1528H3.34782V12.0658H4.26085V11.1528H5.17389V10.2397H4.26085Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6522 10.2397V9.32669H9.73915V10.2397H8.82611V11.1528H9.73915V12.0658H10.6522V11.1528H11.5652V10.2397H10.6522Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKa);
export default __webpack_public_path__ + "static/media/ka.22473bad2b2577bfe72e6883ff2c25ed.svg";
export { ForwardRef as ReactComponent };